<template>
    <section class="painel-grafico" :class="{ aberto: aberto }">
        <header class="painel-header">
            <a
                href="#"
                class="painel-toggle"
                :class="{ ativo: aberto }"
                @click.prevent="$emit('update:aberto', !aberto)"
            >
                <span class="toggle"></span>
                <span class="painel-titulo">{{ titulo }}</span>
            </a>
            <div class="painel-acoes">
                <slot name="info" />
                <span v-if="aberto && dica" class="painel-dica">{{ dica }}</span>
            </div>
        </header>

        <div v-if="aberto" class="painel-body">
            <div
                v-if="desabilitado"
                class="painel-indisponivel"
                role="status"
                aria-disabled="true"
            >
                <i class="bi bi-pause-circle" aria-hidden="true"></i>
                <div>
                    <strong>Indicador indisponível</strong>
                    <p>{{ motivoIndisponivel || 'Dados ainda não disponíveis.' }}</p>
                </div>
            </div>
            <template v-else>
                <div v-if="$slots.filtros" class="painel-filtros">
                    <slot name="filtros" />
                </div>

                <div v-if="carregando" class="loading painel-loading"><div></div></div>
                <div v-else-if="vazio" class="painel-vazio">
                    <i class="bi bi-inbox" aria-hidden="true"></i>
                    Sem dados para o período selecionado.
                </div>
                <div v-else class="chart-wrap" :style="{ height: altura }">
                    <slot />
                </div>
            </template>
        </div>
    </section>
</template>

<script>
export default {
    name: 'PainelGrafico',
    props: {
        titulo: { type: String, required: true },
        aberto: { type: Boolean, default: true },
        carregando: { type: Boolean, default: false },
        vazio: { type: Boolean, default: false },
        dica: { type: String, default: '' },
        altura: { type: String, default: '220px' },
        desabilitado: { type: Boolean, default: false },
        motivoIndisponivel: { type: String, default: '' },
    },
    emits: ['update:aberto'],
};
</script>

<style scoped>
.painel-grafico {
    padding: 0.85rem 1rem 1rem;
    border-bottom: 1px solid var(--cor-separador);
}

.painel-grafico:last-child {
    border-bottom: none;
}

.painel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.painel-toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    text-decoration: none;
    color: inherit;
    font-weight: 600;
}

.painel-titulo {
    font-size: 0.98rem;
}

.painel-acoes {
    display: flex;
    align-items: center;
    gap: 0.65rem;
}

.painel-dica {
    font-size: 0.75rem;
    opacity: 0.65;
}

.painel-body {
    display: grid;
    gap: 0.75rem;
    margin-top: 0.75rem;
}

.painel-filtros {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: end;
}

.painel-filtros :deep(label) {
    display: block;
    font-size: 0.78rem;
    margin-bottom: 0.25rem;
    opacity: 0.75;
}

.painel-filtros :deep(select) {
    min-width: 10rem;
    border-radius: 8px;
}

.chart-wrap {
    width: 100%;
    position: relative;
}

.painel-loading {
    margin: 1rem auto;
}

.painel-vazio {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    min-height: 120px;
    border-radius: 10px;
    font-size: 0.9rem;
    opacity: 0.7;
    background: var(--cor-primaria-fraca);
}

.painel-indisponivel {
    display: flex;
    align-items: flex-start;
    gap: 0.65rem;
    min-height: 120px;
    padding: 1rem;
    border-radius: 10px;
    background: color-mix(in srgb, #6b7280 10%, var(--cor-bg));
    box-shadow: 0 0 0 1px color-mix(in srgb, #6b7280 25%, transparent) inset;
    color: inherit;
    opacity: 0.9;
}

.painel-indisponivel i {
    font-size: 1.25rem;
    opacity: 0.75;
    margin-top: 0.1rem;
}

.painel-indisponivel strong {
    display: block;
    margin-bottom: 0.25rem;
}

.painel-indisponivel p {
    margin: 0;
    font-size: 0.85rem;
    opacity: 0.8;
}
</style>
